import mobileLogo from 'assets/Name - White Transparent.svg'

export function MobileUnauthenticatedNav() {
  return (
    <nav className="w-full p-[20px] pb-[8px] bg-brand">
      <img src={mobileLogo} alt="First Bite" className="h-auto w-[81px]" />
    </nav>
  )
}
